import React, { FC, ReactElement } from 'react';

import styles from './vertically-centered-icon.less';

interface VerticallyCenteredIconProps {
    icon: ReactElement;
    'data-qa'?: string;
}

const VerticallyCenteredIcon: FC<VerticallyCenteredIconProps> = ({ icon, 'data-qa': dataQa }) => {
    return (
        <span className={styles.verticallyCenteredIcon}>
            {React.cloneElement(icon, {
                'data-qa': dataQa,
            })}
        </span>
    );
};
export default VerticallyCenteredIcon;
